import { companyStats } from "@/mocks/homeData";
import { useTranslation } from "react-i18next";

const statKeys = ["experience", "keys", "satisfaction", "partners"] as const;

export default function AboutStats() {
  const { t } = useTranslation();

  return (
    <section className="bg-background-950 py-14 md:py-20">
      <div className="px-4 md:px-6 max-w-6xl mx-auto">
        <div className="mb-10 md:mb-14">
          <span className="text-xs md:text-sm font-medium text-background-50/50 uppercase tracking-wider">
            {t("about.label")}
          </span>
          <p className="font-heading text-xl md:text-3xl lg:text-4xl text-background-50 font-medium mt-3 max-w-2xl leading-relaxed">
            {t("about.text")}
          </p>
        </div>

        <div className="grid grid-cols-2 gap-8 md:gap-12">
          {companyStats.map((stat, index) => (
            <div key={index} className="text-center md:text-left">
              <p className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-accent-500 leading-none">
                {stat.value}
              </p>
              <p className="text-sm md:text-base text-background-50/60 mt-2 md:mt-3 font-medium">
                {t(`about.stats.${statKeys[index]}`)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}